module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_nx-3f6ef7175a4880fb77167a74f96b7796.png";